module.exports = __webpack_public_path__ + "img/profilNoIdentified.ae6ba7ad.svg";